import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

const GoogleAnalyticsDataSender = () => {
  const history = useHistory();
  const lastPageViewSend = useRef('');

  useEffect(
    () =>
      history.listen((location) => {
        if (typeof window.ga === 'function') {
          const pageURL = `${location.pathname}${location.search}`;
          // prevent sending pageView event when hash being changed
          if (lastPageViewSend.current === pageURL) return;
          lastPageViewSend.current = pageURL;

          window.ga('set', 'page', pageURL);
          window.ga('send', 'pageview');
        } else {
          // eslint-disable-next-line no-console
          console.log('Skip GA data send, GA not initialized');
        }
      }),
    [history],
  );

  return null;
};

export default GoogleAnalyticsDataSender;
